export default "__VITE_ASSET__Bh9Y9d7Q__"